/**
 * Strings of the visual overhaul's WP4 (voice room)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one.
 */
import type { Dict } from '../core';

export const voiceEn: Dict = {
  // the header: no connection chip (the dock says it); the count after the name
  'hubv.vr.inVoice': { one: '{n} in voice', other: '{n} in voice' },
  // the control bar: the mic's caret menu and its push-to-talk tag (P21)
  'hubv.vr.inputOptions': 'Input options',
  'hubv.vr.inputSettings': 'Input settings',
  'hubv.vr.pttTag': 'PTT',
  // the member menu's slider item (P12), Discord's "User Volume"
  'ns.voice.volume': 'User volume',
  // phones and tablets (§12.7 B2): push to talk by a held button
  'ns.voice.holdToTalk': 'Hold to talk',
  // a room you are in but cannot see (a moderator moved you into a hidden
  // channel): its name never reaches you, so the dock and the room say this
  'ns.voice.privateRoom': 'Private channel',
};
